import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledRightPaneContainer = styled.div`
    background: ${UI.Tokens.COLOURS.greyscale.cloud};
    height: 100%;
    overflow-y: auto;
`;
